import { render, staticRenderFns } from "./Surrogate.vue?vue&type=template&id=4c79c998&"
import script from "./Surrogate.vue?vue&type=script&lang=js&"
export * from "./Surrogate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports